export default {
  common: {
    cancel: "Cancel",
    close: "Close",
    edit: "Edit",
    archive: "Archive",
    deactivate: "Deactivate",
    confirm: "Confirm",
    none: "None",
    unknown: "Unknown",
    unavailable: "Unavailable",
    system: "System",
    yes: "Yes",
    no: "No",
    loading: "Loading",
    notRecorded: "Not recorded",
    notSelected: "Not selected",
    noReason: "No reason",
    unassigned: "Unassigned",
    sensor: "Sensor",
    gateway: "Gateway",
    device: "Element device",
    elementSensor: "Element sensor",
    metric: "Metric",
    email: "Email",
    messages: "Messages",
    needed: "Needed",
    ready: "Ready",
    noValue: "No value",
    tracked: "Tracked",
    select: "Select",
    resolved: "resolved",
    channels: "channels",
    staff: "staff",
    emails: "emails",
    until: "until",
    model: "Model",
    location: "Location",
    status: "Status",
    notes: "Notes",
    name: "Name",
    description: "Description",
    serialNumber: "Serial Number",
    installLocation: "Install location",
    lastSeen: "Last seen",
    latestReading: "Latest reading",
    maintenance: "Maintenance",
    enabled: "Enabled",
    disabled: "Disabled",
    immediate: "Immediate",
    minutes: "{count} minutes",
    minute: "{count} minute",
    level: "Level {level}",
    and: "AND",
    countSensors: "{count} sensors",
    countSensor: "{count} sensor",
    countSelectedSensors: "{count} selected sensors",
    countSelectedSensor: "{count} selected sensor",
    breachPoint: "{count} breach point in selected range.",
    breachPoints: "{count} breach points in selected range.",
    resultReadings: "{count} readings",
    resultReading: "{count} reading",
    ending: "ending {suffix}",
  },
  enum: {
    area: {
      multi_purpose: "Multi-purpose",
      restroom: "Restroom",
      kitchen: "Kitchen",
      plant_room: "Plant room",
      accommodation: "Accommodation",
      outdoor: "Outdoor",
      wellness: "Wellness",
      pool_spa: "Pool / spa",
      gym: "Gym",
      custom: "Custom",
      general_building: "General building",
      restrooms: "Restrooms",
      kitchens: "Kitchens",
      boiler_plant_rooms: "Boiler / plant rooms",
      residence_hotel_rooms: "Residence / hotel rooms",
    },
    icon: {
      building: "Building",
      restroom: "Restroom",
      utensils: "Utensils",
      settings: "Settings",
      bed: "Bed",
      tree: "Tree",
      pool: "Pool",
      dumbbell: "Dumbbell",
      shield: "Shield",
      custom: "Custom",
    },
    colour: {
      emerald: "Emerald",
      blue: "Blue",
      amber: "Amber",
      purple: "Purple",
      gold: "Gold",
      green: "Green",
      slate: "Slate",
    },
    status: {
      active: "Active",
      inactive: "Inactive",
      archived: "Archived",
      online: "Online",
      offline: "Offline",
      maintenance: "Maintenance",
      open: "Active",
      acknowledged: "Acknowledged",
      resolved: "Resolved",
      suppressed: "Suppressed",
      draft: "Draft",
      adopted: "Adopted",
      provisioning: "Provisioning",
      pending_activation: "Pending activation",
      failed: "Failed",
      normal: "Normal",
      warning: "Warning",
      critical: "Critical",
      info: "Information",
      unknown: "Unknown",
      compliant: "Compliant",
      attention: "Needs attention",
      not_started: "Not started",
      scheduled: "Scheduled",
      retired: "Retired",
      disabled: "Disabled",
    },
    metric: {
      temperature: "Temperature",
      humidity: "Humidity",
      battery: "Battery",
      signal: "Signal",
      gateway_online: "Gateway online",
      sensor_online: "Sensor online",
      co2: "CO₂",
      pm2_5: "PM2.5",
      pm10: "PM10",
      fill_level: "Fill level",
      rainfall: "Rainfall",
      wind_speed: "Wind speed",
      water_leak: "Water leak",
      door_state: "Door state",
      vape_detected: "Vape detected",
      fall_detected: "Fall detected",
      presence: "Presence",
      odor_level: "Odour level",
      location: "Location",
      movement: "Movement",
      compound: "Compound conditions",
    },
    condition: {
      below: "below",
      above: "above",
      equals: "equals",
      not_reporting: "not reporting",
    },
    severity: { info: "Information", warning: "Warning", critical: "Critical" },
    health: {
      normal: "Normal",
      warning: "Warning",
      critical: "Critical",
      offline: "Offline",
    },
    action: {
      triggered: "Triggered",
      acknowledged: "Acknowledged",
      assigned: "Assigned",
      resolved: "Resolved",
      auto_resolved: "Auto-resolved",
      suppressed: "Suppressed",
      maintenance_suppressed: "Suppressed during maintenance",
      notification_sent: "Notification sent",
      notification_failed: "Notification failed",
      escalation_sent: "Escalation sent",
    },
    reading: {
      leak: "Leak",
      dry: "Dry",
      open: "Open",
      closed: "Closed",
      detected: "Detected",
      clear: "Clear",
      occupied: "Occupied",
      vacant: "Vacant",
      elevated: "Elevated",
      normal: "Normal",
    },
    connection: {
      ethernet: "Ethernet",
      wifi: "Wi-Fi",
      cellular: "Cellular",
      lorawan: "LoRaWAN",
    },
    hardware: { gateway: "Gateway", sensor: "Sensor" },
  },
  range: {
    last24Hours: "Last 24 hours",
    last7Days: "Last 7 days",
    lastMonth: "Last month",
    lastYear: "Last year",
    short24h: "24h",
    short7d: "7d",
    short1m: "1m",
    short1y: "1y",
  },
  errors: {
    invalidGatewayEui: "Gateway EUI must be 16 hexadecimal characters.",
    gatewayAlreadyAdopted: "This gateway is already adopted by this club.",
    chirpstackGatewayExists:
      "Gateway already exists in ChirpStack; linking it to this club.",
    zoneKeyExists: "A zone with this key already exists.",
    deviceKeyExists: "A device with this key already exists.",
    invalidDevEui: "DevEUI must be 16 hexadecimal characters.",
    invalidJoinEui: "JoinEUI/AppEUI must be 16 hexadecimal characters.",
    invalidAppKey: "AppKey must be 32 hexadecimal characters.",
    missingLorawanCredentials:
      "DevEUI, JoinEUI/AppEUI, and AppKey are required.",
    thresholdRequired: "Enter a threshold value.",
    notReportingRequired: "Enter the number of minutes without reporting.",
    ruleNameRequired: "Enter a rule name.",
    scopeSensorRequired: "Select a sensor.",
    scopeZoneRequired: "Select a zone.",
    scopeGatewayRequired: "Select a gateway.",
    scopeGroupRequired: "Select a sensor group.",
    recipientRequired:
      "Select at least one staff recipient for Privana Messages.",
    clubCodeMissing: "Club code was not found in the current route.",
    overviewLoad: "Could not load Privana Element monitoring data.",
    zoneLoad: "Unable to load zone detail.",
    graphLoad: "Unable to load graph range.",
    alertRulesLoad: "Unable to load alert rules.",
    alertCentreLoad: "Unable to load alert centre.",
    saveRule: "Unable to save alert rule.",
    deactivateRule: "Unable to deactivate rule.",
    saveZone: "Unable to save Element zone.",
    saveDevice: "Unable to save Element device.",
    adoptHardware: "Unable to adopt hardware.",
    updateHardware: "Unable to update hardware.",
    assignSensor: "Unable to assign sensor.",
    unassignSensor: "Unable to unassign sensor.",
    archiveZone: "Unable to archive zone.",
    deactivateDevice: "Unable to deactivate device.",
    refreshGateway: "Unable to refresh gateway status right now.",
    gatewaySyncFailed: "Gateway sync failed",
    startMaintenance: "Unable to start maintenance.",
    endMaintenance: "Unable to end maintenance.",
    actionAlert: "Unable to {action} alert.",
    cameraDenied:
      "Camera permission was denied. Allow camera access or paste QR text instead.",
    cameraMissing: "No camera was found on this device. Paste QR text instead.",
    cameraStart:
      "Scanner failed to start. Allow camera access, close other camera apps, or paste QR text instead.",
    cameraUnavailable:
      "Camera access is unavailable in this browser context. Use paste fallback or open Privana over HTTPS.",
    scannerRegion: "Scanner container was not rendered before camera start.",
    invalidPairing:
      "This pairing link is invalid. Generate a new link from the desktop modal.",
    pairingConnect: "Unable to connect. Keep this page open and try again.",
    photoDecode:
      "Could not decode a QR code from that photo. Fill the frame with the QR code and try again.",
    connecting: "Privana is still connecting. Try again in a moment.",
  },
  dashboard: {
    loadingLabel: "Loading Privana Element dashboard",
    filterZone: "Filter by zone",
    filterZonePlaceholder: "Filter by Zone",
    allZones: "All Zones",
    selectRange: "Select time range",
    addZone: "Add Zone",
    alertCentre: "Alert Centre",
    manageAlerts: "Manage Alerts",
    refresh: "Refresh",
    gatewayRefreshed: "Gateway status refreshed",
    gatewayRefreshedHelp: "Latest ChirpStack gateway status has been synced.",
    lastRefreshed: "Last refreshed {date}",
    attention: "Privana Element needs attention",
    retry: "Retry",
    kpiLabel: "Privana Element KPI cards",
    systemHealth: "System Health",
    weightedEstate: "Weighted estate score",
    activeAlerts: "Active Alerts",
    openAcknowledged: "Open or acknowledged",
    sensorsOnline: "Sensors Online",
    basedLastSeen: "Based on recent last seen",
    zonesMonitored: "Zones Monitored",
    configuredZones: "Configured Element zones",
    complianceStatus: "Compliance Status",
    fromCompliance: "From compliance logs",
    maintenanceDue: "Maintenance Due",
    dueNext14: "Due in the next 14 days",
    noZones: "No Element zones configured",
    noZonesHelp:
      "Create Element zones for this club to begin monitoring General Building, Restrooms, Kitchens, Plant Rooms, Residence & Hotel Rooms, and Outdoor areas.",
    monitoredZones: "Monitored Zones",
    monitoredZonesHelp:
      "Enterprise safety, environment, hygiene, cold-chain, and outdoor telemetry.",
  },
  zone: {
    unnamed: "Unnamed zone",
    monitoredArea: "Monitored area",
    sensors: "Sensors",
    online: "Online",
    alerts: "Alerts",
    assignedWaiting: "Sensors are assigned; waiting for first readings.",
    setupReady: "Setup ready — assign an adopted sensor to this zone.",
    view: "View Zone",
    editLabel: "Edit {name}",
    archiveLabel: "Archive {name}",
    detail: "Zone Detail",
    sensorDetail: "Sensor Detail",
    expandedGraph: "Expanded Graph",
    loading: "Loading zone…",
    back: "Back",
    backToSensor: "Back to sensor",
    assignedToZone: "Assigned to zone",
    latestMetricPoints: "Latest metric points",
    manage: "Manage Zone",
    edit: "Edit Zone",
    assignSensor: "Assign Sensor",
    noCatalogue: "No catalogue model selected",
    gatewayNetwork: "Gateway / Network",
    noSensors: "No sensors assigned",
    noSensorsHelp:
      "Assign an adopted unassigned sensor to start collecting live Element telemetry for this zone.",
    latestReadings: "Latest Readings",
    noReadings: "No readings for this zone",
    noReadingsHelp: "Readings will appear once devices post telemetry.",
    create: "Create Zone",
    formHelp:
      "Configure how this Element area appears in the active monitoring dashboard.",
    name: "Zone name",
    areaType: "Area type",
    iconKey: "Icon key",
    colourKey: "Colour key",
    descriptionPlaceholder: "What this zone covers…",
    exampleName: "General Building",
    save: "Save Zone",
    archive: "Archive zone",
    archivePrompt:
      "Archive this zone? Existing readings and alerts will be preserved.",
    archiveAction: "Archive Zone",
    archived: "Zone archived",
    archivedHelp: "Existing readings and alerts were preserved.",
    created: "Zone created",
    updated: "Zone updated",
    refreshed: "Privana Element zones have been refreshed.",
    saveFailed: "Zone save failed",
    archiveFailed: "Archive failed",
  },
  readings: {
    temperatureShort: "Temp",
    humidity: "Humidity",
    battery: "Battery",
    noNumericTitle: "No numeric {metric} history",
    noNumericHelp:
      "A trend line will appear once numeric telemetry is received for this metric.",
    chartLabel: "{metric} trend chart",
    expandLabel: "Expand {metric} graph",
    lastUpdated: "Last updated {date}",
    safeRange: "Safe range {min} – {max}",
    noSafeRange: "No threshold configured for a safe-range band.",
    latestValue: "Latest value",
    selectedRange: "Selected range",
    loadingRange: "Loading selected range…",
    loading: "Loading",
    sensorGraphs: "Sensor Graphs",
    liveTelemetry: "Live Element telemetry",
    defaultRange: "Default range: {range}",
    noHistory: "No historical readings yet",
    noHistoryHelp:
      "Graph cards will appear as this sensor posts temperature, humidity, battery, or other Element metrics.",
    noThreshold: "No threshold configured",
    breach: "Breach: {reason}",
    thresholdLimit: "Threshold limit: {limit}",
    severity: "Severity: {severity}",
    threshold: "Threshold: {name}",
  },
  panels: {
    activeAlerts: "Active Alerts",
    noActiveAlerts: "No active alerts",
    noActiveAlertsHelp:
      "Open Element alerts will appear here with acknowledgement and resolution actions.",
    acknowledge: "Acknowledge",
    resolve: "Resolve",
    reviewTelemetry: "Review device telemetry.",
    unassignedZone: "Unassigned zone",
    quickInsights: "Quick Insights",
    complianceSummary: "Compliance Summary",
    currentStatus: "Current status",
    latest: "Latest: {title} · {date}",
    complianceReport: "Compliance report",
    noCompliance: "No compliance reports generated yet",
    noComplianceHelp:
      "Element compliance logs will summarise generated safety, hygiene, and monitoring evidence once reporting is enabled.",
    recentActivity: "Recent Activity",
    telemetry: "Element telemetry",
    noActivity: "No recent activity",
    noActivityHelp:
      "Alerts, readings, and alert actions will populate this feed as devices send telemetry.",
    trend: "24h Trend Overview",
    readingCounts: "Reading counts by hour",
    noTrend: "No 24h readings yet",
    noTrendHelp:
      "Trend bars will appear after live telemetry is ingested from Milesight devices.",
  },
  insight: {
    hardwareReadyTitle: "Hardware adoption ready",
    hardwareReadyDetail: "Adopt hardware once, then assign sensors to zones.",
    offlineOne: "{count} device offline",
    offlineMany: "{count} devices offline",
    offlineDetail: "Review last seen timestamps and LoRaWAN connectivity.",
    alertsOne: "{count} active alert",
    alertsMany: "{count} active alerts",
    alertsDetail: "Acknowledge or resolve alerts from the Active Alerts panel.",
    zonesOne: "{count} zone awaiting sensors",
    zonesMany: "{count} zones awaiting sensors",
    zonesDetail: "Assign adopted unassigned sensors to monitored zones.",
    awaitingTitle: "Awaiting first readings",
    awaitingDetail:
      "The ingestion endpoint is ready for Milesight API/MQTT handoff.",
    sustainabilityTitle: "Sustainability score {score}",
    sustainabilityDetail: "Latest Element sustainability calculation.",
    stableTitle: "Element estate stable",
    stableDetail: "No active exceptions detected across monitored zones.",
  },
  activity: {
    readingTitle: "{metric} reading received",
    actionTitle: "{action} recorded",
  },
  alert: {
    fallbackTitle: "Element alert",
    unknownDevice: "Unknown device",
    assignedTo: "Assigned to {name}",
    acknowledgedBy: "Acknowledged by {name}",
    notAcknowledged: "Not acknowledged",
    takeOwnership: "Take Ownership",
    auditTrail: "Audit Trail",
    auditDescription: "{title} lifecycle events.",
    search: "Search alerts",
    exportSoon: "Export CSV (coming soon)",
    exportSoonTitle: "CSV export coming soon",
    exportSoonHelp:
      "Export is coming soon — TODO: wire Alert Centre CSV export.",
    loading: "Loading alerts…",
    centreHelp:
      "Active, acknowledged, resolved, suppressed, and escalated Privana Element alerts with operational ownership context.",
    historyLoadFailed: "Alert history failed to load",
    actionComplete: "Alert {action} complete",
    ownershipComment: "Taken from Alert Centre",
    manageTitle: "Manage Alerts",
    manageHelp:
      "Create, edit, deactivate, and review Privana Element alert threshold rules.",
    manageGroups: "Manage Sensor Groups",
    createRule: "Create Alert Rule",
    existingRules: "Existing alert rules",
    loadingRules: "Loading rules…",
    noRules: "No alert rules configured",
    noRulesHelp:
      "Create a battery, humidity, temperature, signal, online status, or not-reporting rule to start threshold monitoring.",
    recipients: "Recipients: {recipients}",
    duration: "Duration: {duration}",
    cooldown: "Cooldown: {duration}",
    channels: "Channels: {channels}",
    autoResolve: "Auto-resolve: {value}",
    notifyResolve: "Notify on resolve: {value}",
    escalations: "Escalations: {value}",
    noStaff: "No staff selected",
    recentHistory: "Recent triggered/resolved history",
    sendTest: "Send Test Alert",
    testSent: "TEST alert sent",
    testSentHelp: "Test notification was logged and labelled as TEST.",
    deactivated: "Alert rule deactivated",
    deactivateFailed: "Deactivate failed",
    saved: "Alert rule saved",
    savedHelp: "Privana Element alert thresholds were updated.",
    saveFailed: "Alert rule save failed",
    rulesLoadFailed: "Alert rules failed to load",
    status: {
      active: "Active",
      acknowledged: "Acknowledged",
      resolved: "Resolved",
      suppressed: "Suppressed",
    },
    rule: {
      edit: "Edit Alert Rule",
      create: "Create Alert Rule",
      help: "Configure one condition or require multiple conditions to all stay true for the duration.",
      save: "Save Rule",
      name: "Rule name",
      namePlaceholder: "Battery below 10%",
      severity: "Severity",
      scope: "Scope",
      allSensors: "All sensors",
      specificSensor: "Specific sensor",
      specificZone: "Specific zone",
      specificGateway: "Specific gateway",
      sensorGroupScope: "Sensor group / multiple sensors",
      sensorGroup: "Sensor group",
      selectGroup: "Select sensor group",
      noGroups:
        "No sensor groups configured. Create one from Manage Sensor Groups.",
      durationBefore: "Duration before triggering",
      customMinutes: "Custom minutes",
      repeatInterval: "Cooldown / repeat interval",
      ruleCap: "Rule daily notification cap",
      deviceCap: "Device daily notification cap",
      cycleCap: "Worker cycle notification cap",
      conditions: "Conditions",
      conditionsHelp:
        "All conditions must be true. Add humidity + temperature rows for compound rules.",
      addCondition: "Add condition",
      remove: "Remove",
      minutesNotReporting: "Minutes not reporting",
      threshold: "Threshold",
      escalationPath: "Escalation path",
      escalationHelp:
        "Level 1 uses initial recipients. Levels 2 and 3 send once when unresolved past the configured minutes.",
      escalateAfter: "Escalate after minutes",
      fallbackEmails: "Fallback emails",
      staffRecipients: "Staff recipients",
      staffRecipientsHelp:
        "Privana Messages notifications require selected staff users. Email also uses their staff email addresses.",
      messagesNotification: "Privana Messages notification",
      autoResolveNormal: "Auto-resolve when normal",
      notifyOnResolve: "Notify on resolve",
      manualEmails: "Manual recipient emails (advanced/fallback)",
      selectedRequired:
        "Select at least one staff recipient for Privana Messages.",
      scopeSensor: "Sensor: {name}",
      scopeZone: "Zone: {name}",
      scopeGateway: "Gateway: {name}",
      scopeGroup: "Sensor group: {name}",
      notReporting: "{metric} not reporting for {minutes} minutes",
      comparison: "{metric} {condition} {value}",
      escalationSummary:
        "L{level} after {minutes}m ({staff} staff, {emails} emails, {channels})",
    },
    groups: {
      title: "Manage Sensor Groups",
      help: "Create Element sensor groups separate from zones for alert targeting.",
      name: "Group name",
      namePlaceholder: "All freezers",
      saved: "Sensor group saved",
      archived: "Sensor group archived",
      save: "Save Group",
      create: "Create Group",
    },
  },
  hardware: {
    adoptedTitle: "Adopted Hardware",
    adoptedHelp: "Gateways and sensors registered to this club.",
    manage: "Manage Hardware",
    adopting: "Adopting…",
    adopt: "Adopt Hardware",
    totalSensors: "Total adopted sensors",
    totalGateways: "Total gateways",
    unassignedSensors: "Unassigned sensors",
    offlinePending: "Offline/pending devices",
    overview: "Overview",
    gateways: "Gateways",
    sensors: "Sensors",
    adoptTab: "Adopt hardware",
    gatewaysAdopted: "Gateways adopted",
    sensorsAdopted: "Sensors adopted",
    pendingActivation: "Pending activation",
    onlineDevices: "Online devices",
    overviewTitle: "Adopt hardware once, then assign sensors to zones.",
    overviewHelp:
      "Gateways stay as club-level infrastructure. Sensors remain inventory until assigned to a monitored zone.",
    overviewAssignHelp:
      "Sensors are assigned to zones from within each zone. Use “Assign Sensor” inside a zone to deploy hardware.",
    noGateways: "No gateways adopted",
    noGatewaysHelp:
      "Adopt a gateway to register club-level network infrastructure.",
    noSensors: "No sensors adopted",
    noSensorsHelp: "Adopt sensors, then assign available sensors to zones.",
    gatewayModelMissing: "Gateway model not selected",
    sensorModelMissing: "Sensor model not selected",
    gatewayEui: "Gateway EUI",
    sensorsUsingGateway: "Sensors using gateway",
    connectionType: "Connection type",
    edit: "Edit",
    endMaintenance: "End Maintenance",
    startMaintenance: "Put into Maintenance",
    editHardware: "Edit {kind}",
    editHelp: "Update adopted hardware details.",
    provisioningStatus: "Provisioning status",
    protectedIdentity: "Protected ChirpStack identity.",
    save: "Save Hardware",
    updated: "Hardware updated",
    updatedHelp: "Adopted hardware details were saved.",
    updateFailed: "Hardware update failed",
    adopted: "Hardware adopted",
    adoptedSuccess: "The device is now registered to this club.",
    adoptionFailed: "Adoption failed",
    deactivated: "Device deactivated",
    deactivatedHelp: "Historical readings and alerts were preserved.",
    deactivateFailed: "Deactivate failed",
    deactivateTitle: "Deactivate device",
    deactivatePrompt:
      "Deactivate this device? Historical readings and alerts will be preserved.",
    deactivateAction: "Deactivate Device",
    assignTitle: "Assign Sensor",
    assignHelp: "Select an adopted unassigned sensor for {zone}.",
    thisZone: "this zone",
    unassignedSensor: "Unassigned Sensor",
    noModel: "No model",
    noAssignable: "No assignable sensors",
    noAssignableHelp: "Adopt a new sensor first, then assign it to this zone.",
    adoptInstead: "Adopt new sensor instead",
    assign: "Assign Sensor",
    assigned: "Sensor assigned",
    assignedHelp: "{zone} device list has been refreshed.",
    assignFailed: "Assign failed",
    unassignedToast: "Sensor unassigned",
    unassignedHelp: "The sensor returned to unassigned inventory.",
    unassignFailed: "Unassign failed",
    editAssignment: "Edit assignment",
    unassignFromZone: "Unassign from zone",
    actionsLabel: "Open actions for {name}",
    maintenanceTitle: "Put into Maintenance",
    maintenanceHelp:
      "Suppress alert notifications for this device or gateway while readings continue to be recorded.",
    maintenanceReason: "Maintenance reason",
    maintenancePlaceholder:
      "Replacing batteries, gateway relocation, calibration…",
    optionalEnd: "Optional end date/time",
    startMaintenanceAction: "Start Maintenance",
    maintenanceEnabled: "Maintenance mode enabled",
    maintenanceEnabledHelp: "{device} notifications will be suppressed.",
    maintenanceEnded: "Maintenance ended",
    maintenanceEndedHelp: "{device} alert notifications resumed.",
    maintenanceFailed: "Maintenance failed",
    adoption: {
      step: "Step 1: Choose hardware type",
      regionResolved: "LoRaWAN region: {region}, resolved from {source}.",
      regionClubCountry: "club country {country}",
      regionMissing:
        "LoRaWAN region could not be resolved from this club’s address. Please complete the club address before adopting LoRaWAN hardware.",
      gatewayName: "Gateway name",
      gatewayNamePlaceholder: "Main clubhouse gateway",
      gatewayModel: "Gateway model/catalogue",
      serialOptional: "Serial Number (optional)",
      serialPlaceholder: "Milesight serial number",
      locationPlaceholder: "IT room rack",
      sensorName: "Sensor name",
      sensorNamePlaceholder: "Restrooms leak sensor",
      sensorModel: "Sensor model/catalogue",
      preferredGateway: "Preferred gateway/network",
      pairingCode: "Pairing code / QR code / serial number",
      pairingPlaceholder: "Optional serial or QR reference",
      sensorLocationPlaceholder: "Under sink 2",
      notesPlaceholder: "Optional installation notes",
      gatewayHelp:
        "Gateways require a Gateway EUI for ChirpStack. Serial Number is optional and kept separate from Gateway EUI.",
      scanQr: "Scan QR code",
      scanQrHelp:
        "Scan the QR code from the sensor label or packaging. Privana will extract the LoRaWAN details automatically.",
      scanCamera: "Scan with camera",
      scanPhone: "Scan with your phone",
      scanPhoneHelp:
        "Open this pairing QR on a phone next to the sensor. The mobile scanner will send DevEUI, JoinEUI/AppEUI, AppKey, and detected model back to this desktop session.",
      waitingPhone: "Waiting for phone scan…",
      newQr: "New pairing QR",
      pasteQr: "Paste QR text here if camera scanning is unavailable",
      pasteQrLabel: "Paste QR text",
      parseQr: "Parse QR code",
      stopCamera: "Stop camera",
      credentials: "LoRaWAN credentials",
      appKeyCaptured: "AppKey captured{ending}.",
      appKeyMissing: "AppKey has not been captured yet.",
      devEui: "DevEUI",
      joinEui: "JoinEUI/AppEUI",
      serialNotFound: "Not found yet",
      nextStep:
        "Next step: Find JoinEUI/AppEUI and AppKey in Milesight ToolBox or the device provisioning sheet.",
      manualTitle: "Manual LoRaWAN details — Advanced",
      manualHelp: "Manual entry is for technical installers only.",
      appKeyEncrypted: "Stored encrypted after adoption",
      milesightHelp:
        "Milesight default AppKey is commonly the DevEUI repeated twice. Override if your provisioning sheet says otherwise.",
      qrReady: "{source} parsed. LoRaWAN details are ready for adoption.",
      qrSerialOnly:
        "QR found, but it only contains the serial number. LoRaWAN keys are still required.",
      qrMissingKeys: "QR found, but JoinEUI/AppKey are still required.",
      qrNoCredentials: "{source} found but no LoRaWAN credentials found.",
      phoneSource: "Phone scan",
      phoneModel: "Phone scan received. Sensor model detected: {model}",
      phoneUpdated: "Phone scan received. Desktop fields updated.",
      phoneUnavailable:
        "Unable to connect phone pairing. Paste QR text instead.",
      requestingCamera: "Requesting camera permission…",
      cameraActive:
        "Camera active — fill the box with the QR code. Tap the preview to focus.",
      scanNoCredentials:
        "QR found but no LoRaWAN credentials found. Try scanning again or paste QR text instead.",
    },
  },
  device: {
    edit: "Edit Device",
    add: "Add Device",
    formHelp:
      "Select the catalogue model and manage only the operational details shown to staff.",
    zone: "Zone",
    typeModel: "Device type / catalogue model",
    name: "Device name",
    namePlaceholder: "Kitchen fridge monitor",
    locationPlaceholder: "North wall",
    maintenanceDue: "Maintenance due date",
    save: "Save Device",
    added: "Device added",
    updated: "Device updated",
    refreshed: "Zone device assignments have been refreshed.",
    saveFailed: "Device save failed",
  },
  pairing: {
    connecting: "Connecting to Privana…",
    title: "Scan sensor QR code",
    subtitle:
      "Privana will send the LoRaWAN details back to the desktop adoption modal.",
    boxHelp: "Fill the box with the QR code. Tap to focus.",
    standby: "Camera scanner standby",
    uploadFallback: "Upload/Take Photo fallback",
    upload: "Upload/Take Photo",
    toolboxHelp:
      "Find JoinEUI/AppEUI and AppKey in Milesight ToolBox or the device provisioning sheet.",
    pasteFallback: "Paste QR text fallback",
    pastePlaceholder: "Paste the QR text if camera scanning is unavailable",
    stopCamera: "Stop camera",
    startCamera: "Start camera scanner",
    send: "Send",
    qrSource: "QR code",
    qrReady: "{source} parsed. LoRaWAN details are ready.",
    qrSerialOnly:
      "QR found, but it only contains the serial number. LoRaWAN keys are still required.",
    qrMissingKeys: "QR found, but JoinEUI/AppKey are still required.",
    qrNoCredentials:
      "{source} found but no LoRaWAN credentials found. Try scanning again, taking a photo, or paste QR text.",
    sentReady: "LoRaWAN details sent to the desktop adoption modal.",
    sentPartial: "{status} Details sent to the desktop modal.",
    requestingCamera: "Requesting camera permission…",
    cameraActive:
      "Camera active — fill the box with the QR code. Tap the preview to focus.",
    connectedReopen: "Connected. Reopening the last camera scanner…",
    connectedReady: "Connected. Tap Start camera scanner or Upload/Take Photo.",
    decoding: "Decoding QR from photo…",
    diagnostics: "QR diagnostics",
    diagnosticsMediaDevices: "navigator.mediaDevices available?",
    diagnosticsGetUserMedia: "Camera media access available?",
    diagnosticsSecureContext: "Secure browser context?",
    diagnosticsLocation: "Page location",
    diagnosticsLoaded: "QR scanner loaded successfully?",
    diagnosticsStartError: "QR scanner start error",
    warnings: {
      empty: "Paste or scan a QR code first.",
      serialOnly:
        "QR found, but it only contains the serial number. LoRaWAN keys are still required.",
      missingKeys: "QR found, but JoinEUI/AppKey are still required.",
      partial:
        "Some LoRaWAN details were found, but JoinEUI/AppEUI and AppKey are both required.",
      none: "No LoRaWAN credentials were found. Try pasting the full QR text or use Manual LoRaWAN details.",
      toolbox:
        "Find JoinEUI/AppEUI and AppKey in Milesight ToolBox or the device provisioning sheet.",
      invalidHex: "{field} must be {count} hex characters.",
    },
  },
};
